import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { AuthService } from '../../shared/services/auth.service';
import { UtilService } from '../../shared/services/util.service';

@Component({
  selector: 'app-mfa-login',
  templateUrl: './mfa-login.component.html',
  standalone: false,
  styleUrls: ['./mfa-login.component.scss']
})
export class MfaLoginComponent {
  otp: string = '';
  errorMessage: string = '';
  isLoading: boolean = false;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private utilService: UtilService,
    private router: Router
  ) {}

  onOtpInput(event: any): void {
    const value = event.target.value;
    if (/^\d*$/.test(value) && value.length <= 6) {
      this.otp = value;
    } else {
      event.preventDefault();
    }
  }

  verify(): void {
    if (!this.otp || this.otp.length !== 6) {
      this.errorMessage = 'Please enter a valid 6-digit code';
      return;
    }

    this.errorMessage = '';
    this.isLoading = true;

    const user = this.authService.getUser();
    if (!user || !user.email) {
      this.errorMessage = 'Session expired. Please login again.';
      this.isLoading = false;
      this.router.navigate(['/']);
      return;
    }

    const payload = {
      email: user.email,
      token: this.otp
    };

    this.apiService.postData('/partners/auth/totp-mfa/verify', payload).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && !res.error) {
          this.authService.setUser(res.data);
          this.utilService.navigate('/app/dashboard');
        } else {
          this.errorMessage = res.message || 'Invalid token. Please try again.';
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = 'Verification failed. Please try again.';
      }
    });
  }

  onLogout(): void {
    this.authService.logout();
  }
}